import { render, staticRenderFns } from "./RouterSummaryDialog.vue?vue&type=template&id=f0f7c838"
import script from "./RouterSummaryDialog.vue?vue&type=script&lang=js"
export * from "./RouterSummaryDialog.vue?vue&type=script&lang=js"
import style0 from "./RouterSummaryDialog.vue?vue&type=style&index=0&id=f0f7c838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports